import { Button } from '@/components/ui/button'
import { Checkbox } from '@/components/ui/checkbox'
import { Label } from '@/components/ui/label'
import { Popover, PopoverContent, PopoverTrigger } from '@/components/ui/popover'
import { toggleLayerVisibility } from '@/redux/store/slices/map/mapSlice'
import { useAppDispatch, useAppSelector } from '@redux/hooks/useAppState'
import { layers } from 'honeygrid-types'
import { Layers } from 'lucide-react'
import { useState } from 'react'

import type { LayerType } from 'honeygrid-types'

export const LayerSelector = () => {
	const [open, setOpen] = useState(false)
	const mapLayersState = useAppSelector((state) => state.map.layers)
	const dispatch = useAppDispatch()

	const handleCheckboxChange = (layer: LayerType) => {
		dispatch(toggleLayerVisibility(layer))
	}

	return (
		<Popover open={open} onOpenChange={setOpen}>
			<PopoverTrigger asChild>
				<Button variant="secondary" size="mapTool" className="cursor-pointer">
					<Layers className="h-4 w-4" />
					<span className="sr-only">Select map layers</span>
				</Button>
			</PopoverTrigger>
			<PopoverContent
				className="w-[200px] p-0 rounded-sm shadow-md"
				align="end"
				alignOffset={-8}
				sideOffset={5}
			>
				<div className="divide-y divide-border">
					{layers.map((layer) => (
						<div key={layer.id} className="flex items-center space-x-2 p-3 hover:bg-muted cursor-pointer">
							<Checkbox
								id={layer.id}
								checked={mapLayersState[layer.id]}
								onCheckedChange={() => handleCheckboxChange(layer)}
							/>
							<Label
								htmlFor={layer.id}
								className="text-sm font-medium leading-none peer-disabled:cursor-not-allowed peer-disabled:opacity-70 cursor-pointer"
							>
								{layer.name}
							</Label>
						</div>
					))}
				</div>
			</PopoverContent>
		</Popover>
	)
}
